const TIPOS_IMPORTACION_ESTADO = [
  {
    id: 0,
    name: 'Procesando'
  },
  {
    id: 1,
    name: 'Correcto'
  },
  {
    id: 2,
    name: 'Con Errores'
  },
  {
    id: 3,
    name: 'Revisado'
  },
]

export {
  TIPOS_IMPORTACION_ESTADO
}
